import { CSSProperties, LegacyRef, ReactNode } from 'react';

import './Card.scss';

interface CardProps {
  style?: CSSProperties;
  className?: string;
  innerRef?: LegacyRef<HTMLDivElement>;
  children?: ReactNode;
}

export default function Card({ style, className = '', innerRef, children }: CardProps) {
  return (
    <div style={style} className={`card ${className}`} ref={innerRef}>
      {children}
    </div>
  );
}
